import { render, staticRenderFns } from "./self.vue?vue&type=template&id=2a35d45a&scoped=true"
import script from "./self.vue?vue&type=script&lang=ts"
export * from "./self.vue?vue&type=script&lang=ts"
import style0 from "@/styles/list.scss?vue&type=style&index=0&id=2a35d45a&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a35d45a",
  null
  
)

export default component.exports